import { lazy } from "react";

/** Data files */
//import { securityKey } from "../../utils/ENUMS/SecurityKey";

/** Pages */
import UserManagement from "../../pages/userManagement/UserManagement";
import BasisTypes from "../../pages/basisTypes/BasisTypes";
import ReportTypes from "../../pages/reportTypes/ReportTypes";
import MasterValuationFields from "../../pages/masterValuationFields/MasterValuationFields";
import MasterFieldCategories from "../../pages/masterFieldCategories/MasterFieldCategories";
import Clients from "../../pages/clients/Clients";
import ClientDetails from "../../pages/clients/components/clientDetails/ClientDetails";
import ChangePassword from "../../pages/changePassword/ChangePassword";
import ReportTemplate from "../../pages/reportTemplate/ReportTemplate";
import ReportTemplateList from "../../pages/reportTemplate/components/reportTemplateList/ReportTemplateList";
import WordDocuments from "../../pages/wordDocument/WordDocuments";
import XSDTemplate from "../../pages/xSDTemplate/XSDTemplate";
import XMLReports from "../../pages/xMLReports/XMLReports";
import ClientValuationDetails from "../../pages/clients/components/clientValuationDetails/ClientValuationDetails";
import LiabilityTypes from "../../pages/liabilityTypes/LiabilityTypes";
import { Navigate } from "react-router-dom";


/** Not Found Page */
const NotFound = lazy(() => import("../../pages/notFound/NotFound"));

/** Miscellaneous Pages */
const FormPage = lazy(() => import("../../pages/formPage/FormPage"));
const GridPage = lazy(() => import("../../pages/gridPage/GridPage"));
const Dashboard = lazy(() => import("../../pages/dashboard/Dashboard"));

export const ComponentNavigation = [
  {
    id: "dashboard",
    path: "/",
    exact: true,
    title: "",
    component: Clients,  
   // component: () => <Navigate to="/clients" />,
    text: "dashboard",
    securityKey: "",
  },
  {
    id: "pageNotFound",
    path: "pageNotFound",
    exact: true,
    title: "",
    component: NotFound,
    text: "Page not found",
    securityKey: "",
  },
  {
    id: "changePassword",
    path: "/changePassword",
    exact: true,
    title: "",
    component:ChangePassword,
    text: "Change Password",
    securityKey: "",
  },
  
  {
    id: "dashboard",
    path: "/dashboard",
    exact: true,
    title: "",
    component: Clients,
    text: "dashboard",
    securityKey: "",
  },
  {
    id: "clients",
    path: "/clients",
    exact: true,
    title: "",
    component: Clients,
    text: "clients",
    securityKey: "",
  },
  {
    id: "clientDetails",
    path: "/clientDetails/:id",
    exact: true,
    title: "",
    component: ClientDetails,
    text: "Client Details",
    securityKey: "",
  },
  {
    id: "clientValuationDetails",
    path: "/clientValuationDetails/:id",
    exact: true,
    title: "",
    component: ClientValuationDetails,
    text: "Client Valuation Details",
    securityKey: "",
  },

  // Templates Menu
  {
    id: "report_templates",
    path: "/reportTemplates",
    exact: true,
    title: "",
    component: ReportTemplate,
    text: "Report Templates",
    securityKey: "",
  },
  {
    id: "word_documents",
    path: "/wordDocuments",
    exact: true,
    title: "",
    component: WordDocuments,
    text: "Word Documents",
    securityKey: "",
  },
  {
    id: "xsd_templates",
    path: "/xsdTemplates",
    exact: true,
    title: "",
    component: XSDTemplate,
    text: "XSD Templates",
    securityKey: "",
  },
  {
    id: "xml_reports",
    path: "/xmlReports",
    exact: true,
    title: "",
    component: XMLReports,
    text: "XML Reports",
    securityKey: "",
  },

  // Administrator
  {
    id: "user_management",
    path: "/UserManagement",
    exact: true,
    title: "",
    component: UserManagement,
    text: "User Management",
    securityKey: "",
  },
  {
    id: "basis_types",
    path: "/BasisTypes",
    exact: true,
    title: "",
    component: BasisTypes,
    text: "Basis Types",
    securityKey: "",
  },
  {
    id: "liability_types",
    path: "/liabilityTypes",
    exact: true,
    title: "",
    component: LiabilityTypes,
    text: "Liability Types",
    securityKey: "",
  },
  {
    id: "report_types",
    path: "/ReportTypes",
    exact: true,
    title: "",
    component: ReportTypes,
    text: "Report Types",
    securityKey: "",
  },
  {
    id: "master_valuation_fields",
    path: "/MasterValuationFields",
    exact: true,
    title: "",
    component: MasterValuationFields,
    text: "Master Valuation Fields",
    securityKey: "",
  },
  // {
  //   id: "default_folder_path",
  //   path: "/DefaultFolderPath",
  //   exact: true,
  //   title: "",
  //   component: NotFound,
  //   text: "Default Folder Path",
  //   securityKey: "",
  // },
  {
    id: "master_field_categories",
    path: "/MasterFieldCategories",
    exact: true,
    title: "",
    component: MasterFieldCategories,
    text: "Master Field Categories",
    securityKey: "",
  },

  // Testing Pages for Grid & Form
  {
    id: "formPageId",
    path: "/formPage",
    exact: true,
    title: "Form Page",
    component: FormPage,
    hasParams: false,
    text: "Form Page",
  },

  {
    id: "gridPageId",
    path: "/gridPage",
    exact: true,
    title: "Grid Page",
    component: GridPage,
    hasParams: false,
    text: "Grid Page",
  },
];
